var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-itinerary-section"},[_c('LadItinerarySectionDays',{attrs:{"days":_vm.visibleDays,"limit":_vm.limit}}),_vm._v(" "),(_vm.daysNumber)?_c('LadItinerarySectionPaginate',{attrs:{"days-number":_vm.daysNumber},on:{"change":_vm.handleChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }